import { FormControlLabel, Switch} from '@mui/material'
import { useFilters } from '../../providers/filterprovider'
import FilterInput from './filter-input'

export default function Filter() {
  const { hasFilter, setHasFilter } = useFilters()
  const { filters } = useFilters();
  const appliedFilters: any = []

  filters.forEach(filter => {
    if(filter.data && filter.name) {
      appliedFilters.push(
        <FilterInput
          data={filter.data}
          filteredData={filter.filteredData}
          name={filter.name}
          error={filter.error}
          loading={filter.loading}
          filterAddCallback={filter.filterAddCallback}
          key={filter.name}
        />
      )
    }
  })

  const handleSwitchChange = () => {

    filters.forEach(filter => filter.setData([]))
    setHasFilter(!hasFilter)
  }

  return (
    <div
      className="input-text-wrapper"
      style={{ display: 'flex', alignItems: 'center', height: 50}}
    >
      <FormControlLabel control={<Switch checked={hasFilter} onChange={handleSwitchChange} />} label="Filter" />
      {hasFilter && (<div className='scrollable-div' >
        {appliedFilters}
      </div>)}
    </div>
  )
}
